import PropTypes from 'prop-types';
import { Component } from 'react';
import LoginStylingStore from '../stores/LoginStylingStore';
import AdminActions from '../actions/AdminActions';

class Container extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
  }

  constructor(props) {
    super(props);
    this.state = {
      ready: LoginStylingStore.isReady(),
    };
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    LoginStylingStore.addListener(this._onChange);
    AdminActions.initializeSite();
  }

  _onChange() {
    this.setState({ ready: LoginStylingStore.isReady() });
  }

  render() {
    return this.state.ready && this.props.children;
  }

}

export default Container;
